exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\nbody {\n    /* background: url('/assets/images/dust.png'); */\n    background-color: #383838;\n    background-position: center;\n}\n\n.letter {\n    font-size: 60px;\n    color: rgba(216, 88, 86, 0.7);\n    font-weight: 900;\n}\n\n.subText .letter{\n  color: white;\n  font-size: 20px;\n  font-weight: 300;\n}\n\n.subText .word3 .letter,\n.subText .word6 .letter,\n.subText .word9 .letter{\n  color: rgba(216, 88, 86, 0.7);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/Putman/Desktop/Javascript Projects/angular-portfolio/node_modules/css-loader?{"sourceMap":false,"import":false}!/Users/Putman/Desktop/Javascript Projects/angular-portfolio/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/Users/Putman/Desktop/Javascript Projects/angular-portfolio/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles